import { PaginateList } from '@/app/common/types/common-types';
import { EViewType } from './pages/SalesMaterial/constants';
import { LocationData } from '@/app/common/components/location-autocomplete/location-autocomplete.component';

export type LibraryLocaleItem = {
  id: string;
  locale: string;
  published_at: Date;
  _id: string;
};

export type LibraryColumnRefItem = {
  id?: string;
  column: string;
  module: string;
  weight: number;
};

export type LibraryFileItem = {
  fileName: string;
  importId: string;
  url: number;
};

export type ITypeOfView = {
  includeSA?: boolean;
  type?: EViewType;
  userFile?: any;
  userList?: string[];
  createdAt?: Date;
  updatedAt?: Date;
  published_at?: Date;
  id?: string;
  typeOfViewId?: string | number;
  officeCodes?: string[];
  totalValid?: number;
  totalNotValid?: number;
  totalRecords?: number;
};

export type localeItem = {
  id: string;
  locale: string;
  publishedAt: Date;
  _id: string;
};

export type CategoryItem = {
  createdAt: Date;
  id: string;
  localizations?: localeItem[];
  name: string;
  publishedAt: Date;
  updatedAt: Date;
  lastUpdatedBy: string;
  description: string;
  module?: string;
  children?: any;
  childrenItem?: Record<string, any> | CategoryItem[];
  parent?: Record<string, any> | string;
  level?: string;
  isAvailableOnAgent?: boolean;
  updatedBy?: IUpdatedInfo;
};

type IUpdatedInfo = {
  id: string;
  firstname: string;
  lastname: string;
  username: string;
};

export type LibraryItem = {
  createdAt: Date;
  id: string;
  locale: string;
  localizations?: LibraryLocaleItem[];
  publishedAt: Date;
  updatedAt: Date;
  lastUpdatedBy: string;
  lastUpdatedBySub?: string;
  canShare?: boolean;
  allowedForEProfile?: boolean;
  columnReferences: LibraryColumnRefItem[];
  coverpage: LibraryFileItem;
  data?: any;
  designations?: string[];
  effectiveDate: Date | null;
  expiredDate: Date | null;
  i18nData: any | null;
  introduction: string;
  module: string;
  name: string;
  publishToSetOnly: boolean;
  tag: string[];
  type: string;
  zones: string[];
  category: CategoryItem;
  lastPublishTime?: Date;
  childItems?: LibraryItem[] | string[] | null;
  parentItems?: LibraryItem[] | string[] | { count: number } | null;
  materialOrder?: string[];
  typeOfView?: ITypeOfView | null;
  typeOfViews?: ITypeOfView[];
  notificationMessage?: string;
  status?: string;
  agentType?: string;
  targetAgentType?: string;
  targetAgentList?: string[];
  agents?: string[] | null;
  includedAgents?: string[] | null;
  excludedAgents?: string[] | null;
  uuid?: string;
  checkInUrl?: string | null;
  eventStartDate?: Date | null;
  eventEndDate?: Date | null;
  eventInvitation?: boolean;
  eventInvitationTemplate?: string;
  eventAddress?: string;
  eventLocation?: string;
  eventInvitationRegisterPageType?: string;
  productType?: string;
  eventForOffices?: string[];
  backgroundImage?: any;
  promotionImage?: any;
  updatedBy?: IUpdatedInfo;
  lastUpdatedByName?: string;
  agendaList?: object[];
  textColor?: string | null;
  address?: LocationData | null;
  createdByRole?: string;
  sourceId?: string;
  officeForCheckin: string;
};

export type LibraryPaginateList = PaginateList<LibraryItem> & {
  libraryList: LibraryItem[];
  totalRecords: number;
};

export type LibraryListParam = {
  pageSize?: number;
  page?: number;
  name?: string;
  category?: string;
  status?: string;
  type?: string;
  column?: string;
  createTimeStart?: Date | null;
  createTimeEnd?: Date | null;
  eventStartDate?: Date | string | null;
  eventEndDate?: Date | string | null;
  eventInvitation?: string;
  module?: string;
  officeCodes?: string[];
  roleAdActing?: string;
  lastUpdatedBySub?: string;
  customizeQueryBuilder?: () => Record<string, any> | void;
};

export type ColumnItem = {
  createdAt: Date;
  id: string;
  localizations?: LibraryLocaleItem[];
  name: Record<string, string | undefined>;
  publishedAt: Date;
  updatedAt: Date;
  lastUpdatedBy: string;
  description: string;
  weight: number | null;
  module?: string;
  locale?: string;
};

export type ColumnPaginateList = PaginateList<ColumnItem> & {
  columnList: ColumnItem[];
  totalRecords: number;
};

export type LibraryEditItem = {
  canShare?: boolean;
  allowedForEProfile?: boolean;
  columnReferences?: LibraryColumnRefItem[] | null;
  coverpage?: LibraryFileItem;
  data?: object;
  designations?: string[];
  effectiveDate?: Date | null;
  expiredDate?: Date | null;
  i18nData?: any | null;
  introduction?: string;
  module?: string;
  name?: string;
  publishToSetOnly?: boolean;
  tag?: string[];
  type?: string;
  lastUpdatedBy: string;
  lastUpdatedBySub?: string;
  zones?: string[];
  category?: string | null;
  columnIds?: string[] | null;
  lastPublishTime?: Date;
  childItems?: string[] | null;
  parentItems?: LibraryItem[] | string[] | { count: number } | null;
  materialOrder?: string[];
  typeOfView?: string | null;
  typeOfViews?: (string | number)[];
  notificationMessage?: string;
  status: string;
  checkInUrl?: string;
  eventStartDate?: Date | null;
  eventEndDate?: Date | null;
  eventInvitation?: boolean;
  eventInvitationTemplate?: string;
  eventAddress?: string;
  eventLocation?: string;
  eventInvitationRegisterPageType?: string;
  productType?: string;
  agentType?: string;
  targetAgentType?: string;
  targetAgentList?: string[];
  agents?: string[] | null;
  includedAgents?: string[] | null;
  excludedAgents?: string[] | null;
  eventForOffices?: string[];
  eventForAd?: boolean;
  backgroundImage?: string;
  promotionImage?: string;
  lastUpdatedByName?: string;
  agendaList?: object[];
  textColor?: string | null;
  address?: LocationData | null;
  createdByRole?: string;
  sourceId?: string;
  officeForCheckin: string;
  isSnapshotCategory?: boolean;
};

export type IBgImageRequestParams = {
  name?: string;
  page?: number;
  limit?: number;
  type?: string;
  templateId?: string;
};

export type ImageInfo = {
  uploadedAt: string | null;
  _id: string;
  blobName: string;
  module: string;
  owner: string;
  accessLevel: string;
  mimeType: string;
  blobId: string;
  startsOn: string;
  expiresOn: string;
  url: string;
};

export type BgImageItem = {
  _id: string;
  name: string;
  type: string;
  image: ImageInfo;
  updatedAt: string;
  categoryName: string;
  categoryId: string;
  textColorList?: string[];
};

export type BgImageItemOptions = {
  index: number;
  id: string;
  value: string;
  imgUrl: string;
  label: string;
  textColorList?: string[];
};

export type BgImagePaginateList = {
  items: BgImageItemOptions[];
  totalRecords: number;
  page: number;
  limit: number;
};

export type IFile = {
  id: string;
  fileName: string;
  url: string;
  fileType: string;
  importId: string;
};

export type IBgImageDetail = {
  _id: string;
  name: string;
  type: string;
  categoryId: string;
  image: IFile;
  createdAt: string;
  updatedAt: string;
  categoryName: string;
  categoryDescription: string;
  textColorList?: string[];
};

export type ICoverpageDetail = {
  _id: string;
  uploadedAt: string;
  status: string;
  malwareScanningResult: string;
  blobName: string;
  module: string;
  owner: string;
  accessLevel: string;
  mimeType: string;
  createdAt: string;
  updatedAt: string;
  blobId: string;
  url: string;
  startsOn: string;
  expiresOn: string;
};

export type PromotionImageDetail = {
  _id: string;
  name: string;
  image: IFile;
  createdAt: string;
  updatedAt: string;
  createdBy?: string;
  updatedBy?: string;
};

export const mainLang = 'vi';
export const subLang = 'en';

export type UploadFile = {
  fileName: string;
  url: string;
  id: string;
} | null;

export type SharedInfoState = {
  name?: string;
  coverpage?: UploadFile;
  introduction?: string;
  tag?: string[];
  file?: UploadFile;
  link?: string;
  content?: string;
  canShared?: string;
  sharedTitle?: string;
  sharedCoverpage?: UploadFile;
  sharedIntroduction?: string;
  bottomBar?: string;
  bottomBarFor?: string;
  allowedForEProfile?: string;
  address?: LocationData | null;
};

export type ResourceLibraryFormState = {
  rType: string;
  category: {
    value: string;
    label: string;
  };
  productType?: string;
  lastUpdatedBy: string;
  status: string;
  materialSet: any[];
  eventInvitation: string;
  [mainLang]?: SharedInfoState;
  [subLang]?: SharedInfoState;
  agent?: string;
  moduleColumn: { column: string; weight: number | null }[];
  effectiveRange?: [string, string];
  isPublish?: string;
  allWeights?: { [key: string]: string[] };
  designations?: string[];
  zones?: string[];
  resourceId?: string;
  underMaterialSetIDs?: string[];
  removedMaterials?: any[];
  data?: any;
  parentItems?: LibraryItem[] | string[] | { count: number } | null;
  typeOfViews: ITypeOfView[];
  notificationMessage?: string;
  eventDate?: [string, string];
  checkInUrl?: string;
  eventInvitationTemplate?: string;
  eventAddress?: string;
  eventLocation?: string;
  eventInvitationRegisterPageType?: string;
  agentType?: string;
  targetAgentType?: string;
  targetAgentList?: string[];
  agents?: string[];
  includedAgents?: string[];
  excludedAgents?: string[];
  eventForOffices?: string[];
  eventForAd?: boolean;
  backgroundImage?: any;
  promotionImage?: any;
  agendaList?: object[];
  textColor?: string | null;
  address?: LocationData | null;
  lastUpdatedBySub: string;
  createdByRole: string;
  officeForCheckin: string;
  sourceId?: string;
  isSnapshotCategory?: boolean;
};

export type PromotionImageItemOptions = {
  index: number;
  id: string;
  value: string;
  imgUrl: string;
  label: string;
};

export type PromotionImagePaginateList = {
  items: PromotionImageItemOptions[];
  totalRecords: number;
  page: number;
  limit: number;
};

export type CategoryPaginateList = PaginateList<CategoryItem> & {
  categoryList: CategoryItem[];
  totalRecords: number;
};

export enum CategoryLevel {
  ONE = 'one',
  TWO = 'two',
  THREE = 'three',
}
